/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { I18n } from '@coze-arch/i18n';

export const KISRA_LANG_OVERRIDE_KEY = 'kisra_lang_override';

type UpdateFn = () => void;
let _updateFn: UpdateFn | null = null;

export const registerLangUpdate = (fn: UpdateFn) => {
  _updateFn = fn;
};

export const unregisterLangUpdate = () => {
  _updateFn = null;
};

export const getLangOverride = (): string | null =>
  localStorage.getItem(KISRA_LANG_OVERRIDE_KEY);

export const setLangOverride = async (lang: string) => {
  localStorage.setItem(KISRA_LANG_OVERRIDE_KEY, lang);
  localStorage.setItem('i18next', lang);
  await I18n.setLangWithPromise(lang);
  window.location.reload();
};
